import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TeamDisplay = () => {
  const navigate = useNavigate();
  const [teamData, setTeamData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchTeamData();
  }, []);

  const fetchTeamData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api-teams-kvw-herten.ipg.nu';
      const response = await fetch(`${apiUrl}/api/team`, {
        credentials: 'include'
      });
      
      if (!response.ok) {
        if (response.status === 401) {
          // Session expired or not authenticated
          navigate('/');
          return;
        }
        const errorData = await response.json();
        throw new Error(errorData.message || 'Team niet gevonden');
      }

      const data = await response.json();
      setTeamData(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api-teams-kvw-herten.ipg.nu';
      await fetch(`${apiUrl}/api/logout`, {
        method: 'POST',
        credentials: 'include'
      });
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      navigate('/');
    }
  };

  if (loading) {
    return (
      <div className="team-container">
        <div className="loading">Team gegevens laden...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="team-container">
        <div className="error-message">{error}</div>
        <button onClick={handleLogout} className="back-button">
          Terug naar login
        </button>
      </div>
    );
  }

  return (
    <div className="team-container">
      {/* KVW Logo */}
      <img src="/logo.jpeg" alt="KVW Logo" className="kvw-logo" />

      <div className="team-header">
        <h1 className="team-title">{teamData?.team_display || `Team ${teamData?.team_number}`}</h1>
      </div>

      {teamData?.leaders && teamData.leaders.length > 0 && (
        <div className="team-section leaders-section">
          <h2 className="section-title leaders-title">👑 Jeugdleiding</h2>
          <ul className="member-list leaders-list">
            {teamData.leaders.map((leader) => (
              <li key={leader.participant_number} className="member-item leader-item">
                <span className="member-name">{leader.full_name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="team-section members-section">
        {teamData?.leaders && teamData.leaders.length > 0 && (
          <h2 className="section-title members-title">👥 Deelnemers</h2>
        )}
        <ul className="member-list">
          {teamData?.members?.map((member) => (
            <li key={member.participant_number} className="member-item">
              <span className="member-name">{member.full_name}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="action-buttons">
        <button onClick={handleLogout} className="back-button">
          Terug naar zoeken
        </button>
      </div>
    </div>
  );
};

export default TeamDisplay;
